import { Subject } from "rxjs";
import apiResponse from "../../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  parentsChannel = new Subject();
  regionCountryChannel = new Subject();
  regionProvinceChannel = new Subject();
  regionCityChannel = new Subject();
  createChannel = new Subject();
  relationshipStatusChannel = new Subject();
  maritalStatusChannel = new Subject();
  satkerGajiWebChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.parentsChannel.next({ status: apiResponse.INITIAL });
    this.regionCountryChannel.next({ status: apiResponse.INITIAL });
    this.regionProvinceChannel.next({ status: apiResponse.INITIAL });
    this.regionCityChannel.next({ status: apiResponse.INITIAL });
    this.relationshipStatusChannel.next({ status: apiResponse.INITIAL });
    this.maritalStatusChannel.next({ status: apiResponse.INITIAL });
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.satkerGajiWebChannel.next({ status: apiResponse.INITIAL });
  }

  fetchMaritalStatus = async (query) => {
    try {
      this.maritalStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchMaritalStatus(query)
        .then((result) => {
          this.maritalStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.maritalStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRelationshipStatus = async (query) => {
    try {
      this.relationshipStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRelationshipStatus(query)
        .then((result) => {
          this.relationshipStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.relationshipStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchParents = async (query) => {
    try {
      this.parentsChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchParents(query)
        .then((result) => {
          this.parentsChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.parentsChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionCountry = async (query) => {
    try {
      this.regionCountryChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCountry(query)
        .then((result) => {
          this.regionCountryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCountryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionProvince = async (query) => {
    try {
      this.regionProvinceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionProvince(query)
        .then((result) => {
          this.regionProvinceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionProvinceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionCity = async (query) => {
    try {
      this.regionCityChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCity(query)
        .then((result) => {
          this.regionCityChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCityChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchSatkerGajiWeb = async (query) => {
    try {
      this.satkerGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSatkerGajiWeb(query)
        .then((result) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default CreateBloc;
